module.exports = "<p class=\"input-group\"><input type=\"text\" uib-datepicker-popup=\"shortDate\" ng-model=\"$ctrl.field\" is-open=\"$ctrl.isOpen\" close-text=\"Close\" class=\"form-control\"><span class=\"input-group-btn\"><button type=\"button\" ng-click=\"$ctrl.isOpen = !$ctrl.isOpen\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p>"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./~/jade-html-loader!./app/common/widgets/datePickers/datePicker.jade
// module id = 561
// module chunks = 0